import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/header';
import RequestCertificateCard from '../components/home/requestCertificateCard';
import MyRequestsList from '../components/home/requestlist';
import Modal from '../components/modal';
import UpdateShopNameForm from '../components/home/updateShopNameForm';
import { get, put } from '../config/api';
import { Loader } from '../components/loader';
import { setErrorFlag } from '../store/slices/errorConfig';
import { useDispatch } from 'react-redux';
import { configConstants } from '../constants/textconstants';
import { API_ENDPOINTS } from '../config/apiEndpoints';

interface Request {
  request_id: string;
  license_number: string;
  license_expiry_date: string;
  deliveryCode?: string;
  products: string[];
  status: string;
}

interface Locations {
  code: string;
  name: string;
  level: string;
}

export interface UserInfo {
  id: string;
  name: string;
  type: string;
  primaryPhoneNumber: string;
  address: string;
  postalCode: string;
  status: string;
  registeredDate: string;
  lastAccessedDate: string;
  locations: Locations[];
  shop_name?: string;
}

export const Home: React.FC = () => {
  const [requests, setRequests] = useState<Request[]>([]);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [userData, setUserData] = useState<any>();
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const hasFetched = useRef(false);

  const fetchRequests = async (currentPage: number) => {
    
    setIsLoading(true)
    try {
      let userId = await localStorage.getItem('USER_ID');
      const response = await get(API_ENDPOINTS.GET_PARTNER_CERTIFICATE_REQUESTS(userId,  currentPage, 10));

      if (response) {
        const newItems = response.items || [];
        setRequests(prev => [...prev, ...newItems]);
        setHasMore(newItems.length > 0 && (currentPage + 1) * 10 < response.total);
        setPage(currentPage + 1);
      } else {
        setHasMore(false);
        dispatch(setErrorFlag({ isError: true, errorMsg: 'Loading Requests Failed!!!' }));
      }
    } catch (error) {
      setHasMore(false);
      dispatch(setErrorFlag({ isError: true, errorMsg: 'Loading Requests Failed!!!' }));
      console.error('Error fetching requests:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerHeight + document.documentElement.scrollTop < document.documentElement.offsetHeight - 50 || isLoading || !hasMore) {
        return;
      }
      fetchRequests(page);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isLoading, hasMore, page]);

  const fetchUserData = async () => {
     try{
         let user:any = await localStorage.getItem('userData');
         setUserData(JSON.parse(user));
      }catch(error){
          console.log(error)
      }
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const userid = searchParams.get('userId');
    const userstate = searchParams.get('state');

    if (!userid || !userstate) {
      navigate('/error');
      return;
    }

    if (userid) {
      localStorage.setItem('USER_ID', userid);
    }
    if (userstate) {
      localStorage.setItem('USER_STATE', userstate);
    }

    if (!hasFetched.current) {
      hasFetched.current = true;
      fetchRequests(1);
      fetchUserData();
    }
  }, []);

  const handleRequestNow = () => {
    //console.log(userData, userData.shop_name == null , userData.shop_name === '' , userData.shop_name === undefined)
    if (userData.shop_name == null || userData.shop_name === '' || userData.shop_name === undefined) {
      setIsModalOpen(true);
    } else {
      navigate('/request-certificate', { state: { request: {...userData, fromHome: true} } });
    }
  };

  const handleHelpClick = () => {
    navigate('/help');
  };

  const handleSaveShopName = async (shopName: string) => {
    let userId:any = await localStorage.getItem('USER_ID');
    put(API_ENDPOINTS.UPDATE_SHOPNAME(userId,shopName),{});

    await setUserData({ ...userData, shop_name: shopName });
    await localStorage.setItem("userData", JSON.stringify({...userData,shop_name: shopName }))
    setIsModalOpen(false);
    navigate('/request-certificate', { state: { request: {...userData, shop_name: shopName, fromHome: true}  } });
  };
  const refreshRequests = async () => {
    setRequests([]);
    setPage(0);
    setHasMore(true);
    await fetchRequests(1);
  };

  //console.log(requests,'-')
  const hasPendingRequests = requests.some(request => (request.status.toLowerCase() === 'pending approval')|| (request.status.toLowerCase() === 'pending delivery')|| request.status.toLowerCase() === 'active' ||  request.status.toLowerCase() === 'certificate issuance');

  return (
    <div className="page-container">
      {isLoading && <Loader />}
      <Header title="Principal Certificate" actionText="Need Help?" onActionClick={handleHelpClick} />
      
    
      {userData && <RequestCertificateCard 
      onRequestClick={handleRequestNow}
      isEnabled={userData.isAllowedForPCRequest}
      hasPendingRequests={hasPendingRequests}
      />}
      
      
      {requests && <MyRequestsList requests={requests} onRefresh={refreshRequests} />}

      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <UpdateShopNameForm onSave={handleSaveShopName} />
      </Modal>
    </div>
  );
};